export default __webpack_public_path__ + "static/media/searchMenuIcon.4f6857fe.svg";